import { render } from "./OrdersManagerOrdersStage.vue?vue&type=template&id=7c6f8dd2"
import script from "./OrdersManagerOrdersStage.vue?vue&type=script&lang=js"
export * from "./OrdersManagerOrdersStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__